import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/src/stylus/app.styl';
import hu from 'vuetify/es5/locale/hu';

Vue.use(Vuetify, {
  theme: {
    primary: '#008179',
    secondary: '#292929',
    tertiary: '#b0bec5',
  },
  iconfont: 'md',
  lang: {
    locales: { hu },
    current: 'hu',
  },
});
